import Dialog, { DialogActions, DialogContent, DialogTitle } from "./Dialog";
import ConfirmDialog from "./ConfirmDialog";

export default Dialog;
export { DialogContent, DialogActions, ConfirmDialog, DialogTitle };
